import { Component } from '@angular/core';
import { TasksService } from './tasks.service';
import * as myGlobals from '../../globals';
import { Configuration } from '../../app.configuration';
import { Router } from '@angular/router';

declare var jQuery: any;
declare var $: any;
declare var moment: any;
declare var google: any;
declare var flatpickr: any;
declare var moment: any;
declare var toastr: any;

@Component({
  selector: 'tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['../dispatcherhome/dispatcherhome.component.css', './tasks.component.css']
})
export class TasksComponent {

  tasks: any;
  disphome: any;
  jobdetails: any;
  invoice: any;
  cancelbooking: any;

  passDetailsContent: any;
  search: any;
  search_value: any;
  ent_driver_bid: any;
  driver_bid: any;
  driver_id: any;
  current_time: any;
  fname_b: any;
  fmail_b: any;
  route_map_lt: any;
  route_map_lng: any;
  style: any;
  mapr: any;
  cancel_status_link: any;
  ent_page_index: number = 0;
  today_task: boolean = false;
  all_task: boolean = false;
  custom_select: boolean = false;
  export_start_date: any;
  export_end_date: any;
  export_date_time: any;
  stockData: any;
  request_all: any;
  data1 = [];
  bulk_array = [];
  fphone_b: any;
  ent_request_type_num = 0;
  response_int: number = 0;
  myname;
  myphn;
  mymail;
  cancellation_bid: any;
  cancel_reasons = [];
  type = 3;
  limit = 10;
  skip = 0;
  status = '';
  fromDate = '';
  toDate = '';
  bookingSearch = '';
  bookings: any;
  totcount: any;
  range = 10;
  pageno = 1;
  outoff = 10;
  previousEnable = true;
  nextEnable = false;
  showbooking_content: any;
  cityRange = ['10', '50', '100', '500'];
  directionsDisplay: any;
  allroute_markers = [];
  invoice_url = myGlobals.INVOICE_URL;
  showDimension = myGlobals.enableDimensions;

  constructor(private _router: Router, private _cookie: Configuration, private _service: TasksService ) {}
  loc_reload() {
    this.bookings = [];
    this.fromDate = '';
    this.toDate = '';
    this.search = '';
    this.status = '';
    this.limit = 10;
    this.skip = 0;
    this.range = 10;
    $('#searchKey').val('');
    this.getAllBooking();

    // this.fromDate = '';
    // this.toDate = '';
    // this.status = '';
    // this.search = '';
    // $('#searchKey').val('');
    // this.getAllBooking();
  }

  getAllBooking() {
    console.log(this.search);
    $("#loader_bookings_parent").show();
    this._service.getAllBooking({
      type: this.type,
      limit: this.limit,
      skip: this.skip,
      status: this.status,
      fromDate: this.fromDate,
      toDate: this.toDate,
      search: this.search,
      cityId: '0'
    }).subscribe((res: any) => {
      this.bookings = [];
      if (this.skip <= 0) {
        $('#prev').click(function (e) {
          e.preventDefault();
        });
      }
      console.log("all bookings------------->", res.data);
      $("#loader_bookings_parent").hide();
      if (res.data.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
      }
      else {
        for (let i = 0; i < res.data.bookings.length; i++) {
          if (res.data.bookings[i].bookingDate != 0) {
            res.data.bookings[i].bookingDate = moment(res.data.bookings[i].bookingDate).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].deliveryDate != 0) {
            res.data.bookings[i].deliveryDate = moment(res.data.bookings[i].deliveryDate).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.accepted != 0) {
            res.data.bookings[i].dateAndTime.accepted = moment(res.data.bookings[i].dateAndTime.accepted).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.onTheWay != 0) {
            res.data.bookings[i].dateAndTime.onTheWay = moment(res.data.bookings[i].dateAndTime.onTheWay).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.arrived != 0) {
            res.data.bookings[i].dateAndTime.arrived = moment(res.data.bookings[i].dateAndTime.arrived).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.created != 0) {
            res.data.bookings[i].dateAndTime.created = moment(res.data.bookings[i].dateAndTime.created).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.cancelled != 0) {
            res.data.bookings[i].dateAndTime.cancelled = moment(res.data.bookings[i].dateAndTime.cancelled).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.reachedDrop != 0) {
            res.data.bookings[i].dateAndTime.reachedDrop = moment(res.data.bookings[i].dateAndTime.reachedDrop).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.journeyComplete != 0) {
            res.data.bookings[i].dateAndTime.journeyComplete = moment(res.data.bookings[i].dateAndTime.journeyComplete).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.journeyStart != 0) {
            res.data.bookings[i].dateAndTime.journeyStart = moment(res.data.bookings[i].dateAndTime.journeyStart).format("MMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.unloaded != 0) {
            res.data.bookings[i].dateAndTime.unloaded = moment(res.data.bookings[i].dateAndTime.unloaded).format("MMM Do YYYY, h:mm:ss a");
          }
        }
        this.bookings = res.data.bookings;
        console.log('bookingaaaaaaaaa', this.bookings);
        this.totcount = res.data.count;
        if (this.totcount < this.outoff) {
          this.outoff = this.totcount;
          this.nextEnable = true;
        } else {
          this.outoff = this.skip + this.range;
          this.nextEnable = false;
        }
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#loader_bookings_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err.error);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err.error);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            // this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err.error);
            toastr["error"](this.errMsg.message);
            // $("#loader_bookings_parent").hide();
            // this.errmessage = JSON.parse(err.error);
            // console.log(this.errmessage.message);
            // this.errmessage = this.errmessage.message;
            break;
        }
      })
  }

  // check for enable or disable the buttons based on count
  checkForEnable(count) {
    if (count == 0) {
      this.previousEnable = true;
    } else {
      this.previousEnable = false;
    }

    const totalpages = Math.ceil(this.totcount / this.limit);
    if (this.pageno >= totalpages) {
      this.nextEnable = true;
    } else {
      this.nextEnable = false;
    }
  }

  nextbooks() {
    this.pageno++;
    this.limit = this.range;
    let inst = this.pageno - 1;
    this.checkForEnable(inst);
    this.skip = inst * this.limit;
    this.outoff = this.skip + this.range;
    this.getAllBooking();

    // this.pageno++;
    // this.limit = this.range;
    // let inst = this.pageno - 1;
    // this.checkForEnable(inst);
    // this.skip = inst * this.limit;
    // this.outoff = this.skip + this.range;
    // if(this.outoff > this.totcount) {
    //   this.outoff = this.totcount;
    // } else {
    //   this.outoff = this.skip + this.range;
    // }
    // this.getAllBooking();
  }

  prevbooks() {
    this.pageno--;
    this.limit = this.range;
    let inst = this.pageno - 1;
    this.checkForEnable(inst);
    this.skip = inst * this.limit;
    this.outoff = this.skip + this.range;
    this.getAllBooking();
  }

  setSearchTerm(event) {
    this.search = event.target.value;
  }
  rangebooks(event) {
    this.range = parseInt(event.target.value);
    this.bookings = [];
    this.pageno = 1;
    this.limit = this.range;
    this.skip = 0;
    this.status = '';
    this.limit = this.range;
    let inst = this.pageno - 1;
    this.checkForEnable(inst);
    this.skip = inst * this.limit;
    this.outoff = this.skip + this.range;
    this.getAllBooking();

    // this.range = parseInt(event.target.value);
    // this.bookings = [];
    // this.pageno = 1;
    // this.limit = this.range;
    // this.skip = 0;
    // this.status = '';
    // // this.search = '';
    // this.limit = this.range;
    // let inst = this.pageno - 1;
    // this.checkForEnable(inst);
    // this.skip = inst * this.limit;
    // this.outoff = this.skip + this.range;
    // this.getAllBooking();
  }

  dataSearch() {
    this.search = $("#searchKey").val();
    if (this.search == "") {
      alert("Please enter valid keyword!");
    }
    else {
      $("#loader_bookings_parent").show();
      this.getAllBooking();
    }
  }

  colorSearch(val) {
    this.search = '';
    $('#searchKey').val('');
    $('#filters_but_body').hide();
    this.status = val;
    $("#loader_bookings_parent").show();
    this.getAllBooking();
  }

  passDetailsContent1: any;
  getCustomerBookings(bookingId) {
    $("#appt_loader_parent").show();
    this._service.getdata({
      bookingId: bookingId
    }).subscribe((res: any) => {
      this.passDetailsContent1 = res.data;
      $("#appt_loader_parent").hide();

      if (res.data.dateAndTime.accepted != 0) {
        res.data.dateAndTime.accepted = moment(res.data.dateAndTime.accepted).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.onTheWay != 0) {
        res.data.dateAndTime.onTheWay = moment(res.data.dateAndTime.onTheWay).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.arrived != 0) {
        res.data.dateAndTime.arrived = moment(res.data.dateAndTime.arrived).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.created != 0) {
        res.data.dateAndTime.created = moment(res.data.dateAndTime.created).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.cancelled != 0) {
        res.data.dateAndTime.cancelled = moment(res.data.dateAndTime.cancelled).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.journeyComplete != 0) {
        res.data.dateAndTime.journeyComplete = moment(res.data.dateAndTime.journeyComplete).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.journeyStart != 0) {
        res.data.dateAndTime.journeyStart = moment(res.data.dateAndTime.journeyStart).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.unloaded != 0) {
        res.data.dateAndTime.unloaded = moment(res.data.dateAndTime.unloaded).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.expired != 0) {
        res.data.dateAndTime.expired = moment(res.data.dateAndTime.expired).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.loaded != 0) {
        res.data.dateAndTime.loaded = moment(res.data.dateAndTime.loaded).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.reachedDrop != 0) {
        res.data.dateAndTime.reachedDrop = moment(res.data.dateAndTime.reachedDrop).format("MMMM Do YYYY, h:mm:ss a");
      }
    });
  }


  // get_det(){
  // this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
  //   $("#loader_bookings_parent").show();
  //     this._dispatcherService.getdet({
  //       "ent_end_date": "",
  //       "ent_start_date":"",
  //       "ent_page_index": this.ent_page_index.toString(),
  //     }).subscribe((res: any) => {
  //       console.log("response------------------------------",res);
  //      if(res.errFlag==0){
  //        if(res.data.appointments.length>0){
  //        this.response_int=0;
  //                if(res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime!=undefined){
  //                     if (res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime != "0"){
  //                         res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime).format("MMMM Do YYYY, h:mm:ss a");
  //                     }
  //                     if (res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime != "0")
  //                         res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime).format("MMMM Do YYYY, h:mm:ss a");


  //                     if (res.data.appointments[0].shipemntDetails[0].DriverArrivedTime != "0")
  //                         res.data.appointments[0].shipemntDetails[0].DriverArrivedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverArrivedTime).format("MMMM Do YYYY, h:mm:ss a");

  //                     if (res.data.appointments[0].shipemntDetails[0].DriverCompletedTime != "0")
  //                         res.data.appointments[0].shipemntDetails[0].DriverCompletedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverCompletedTime).format("MMMM Do YYYY, h:mm:ss a");

  //                     if (res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime != "0")
  //                         res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime).format("MMMM Do YYYY, h:mm:ss a");

  //                      if (res.data.appointments[0].shipemntDetails[0].DriverDropedTime != "0")
  //                        res.data.appointments[0].shipemntDetails[0].DriverDropedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverDropedTime).format("MMMM Do YYYY, h:mm:ss a");
  //         }
  //       //  $(".load_more_tabs").removeAttr("disabled");
  //         $("#loader_bookings_parent").hide();
  //       console.log("dispathcer_service");
  //       console.log(res: any);
  //       console.log("before finding arry",this.data1);
  //        for(;this.response_int<res.data.appointments.length;this.response_int++){
  //                 this.data1.push(res.data.appointments[this.response_int]);
  //                 console.log(res.data.appointments[this.response_int]);
  //        }
  //      }
  //      else{
  //         $("#loader_bookings_parent").hide();
  //      }
  //      }
  //      else{
  //        alert(res.errMsg);
  //      }
  //     });
  // }

  savedriver(bid) {
    this.driver_bid = bid;
    this.cancel_status_link = 1;
    // console.log("dklfjaslkdjfklasdf------------------------------------------------------", this.driver_bid);
  }

  displayRoute() {
    const options = {
      zoom: 3,
      center: new google.maps.LatLng(45.50867, -73.553992),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
    };

    this.mapr = new google.maps.Map(document.getElementById('map3'), options);
    this.mapr.setOptions({
      // styles: that.style,
      minZoom: 2, maxZoom: 20
    });
    const pos1 = new google.maps.LatLng(this.route_map_lt.latitude, this.route_map_lt.longitude);
    const pos2 = new google.maps.LatLng(this.route_map_lng.latitude, this.route_map_lng.longitude);
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.mapr
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.mapr
    });
    this.allroute_markers.push(marker2);
    const directionsService2 = new google.maps.DirectionsService({ preserveViewport: true });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      // polylineOptions: { strokeColor: '#00ff5b' }
    });
    this.directionsDisplay.setMap(this.mapr);
    const request = {
      origin: pos1, // LatLng|string
      destination: pos2, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsService2.route(request, (response, status) => {
      if (status == 'OK') {
        console.log(response);
        const point = response.routes[0].legs[0];
        let journey_time = point.distance.value;
        journey_time = journey_time / 1000;
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(this.mapr, 'bounds_changed', (event) => {
          if (journey_time <= 100) {
            this.mapr.setZoom(12);
          }
          else if (journey_time > 100 && journey_time < 500) {
            this.mapr.setZoom(8);
          }
          else if (journey_time > 500 && journey_time < 1500) {
            this.mapr.setZoom(6);
          }
          else if (journey_time > 1500 && journey_time < 1000) {
            this.mapr.setZoom(5);
          }
          else if (journey_time < 1000) {
            this.mapr.setZoom(3);
          }
          google.maps.event.trigger(this.mapr, 'resize');
        });
        setTimeout(function () { google.maps.event.removeListener(zoomChangeBoundsListener); }, 1000);
        this.directionsDisplay.setDirections(response);
      }
    });
  }


  // THIS FUNCTION IS INTEDED TO LOAD THE MAP AFTER DETAILS BUTTON CLICK AFTER 0.5 SECOND
  // AND SHOWS ROUTE FROM POINT GOT FROM API
  // displayRoute() {
  //   var options = {
  //     zoom: 3,
  //     center: new google.maps.LatLng(45.50867, -73.553992),
  //     mapTypeId: google.maps.MapTypeId.ROADMAP,
  //     disableDefaultUI: true,
  //   };
  //   // END OF MAP STYLE
  //   // MAP LOADING 

  //   var that = this;
  //   that.mapr = new google.maps.Map(document.getElementById('map3'), {
  //     center: { lat: -34.397, lng: 150.644 },
  //     zoom: 8
  //   });
  //   that.mapr.setOptions({
  //     // styles: that.style,
  //     minZoom: 2, maxZoom: 20
  //   });

  //   setTimeout(() => {
  //     const bounds = new google.maps.LatLngBounds();
  //     const start = new google.maps.LatLng(this.route_map_lt.latitude, this.route_map_lt.longitude);
  //     const end = new google.maps.LatLng(this.route_map_lng.latitude, this.route_map_lng.longitude);

  //     const directionsDisplay = new google.maps.DirectionsRenderer();// also, constructor can get "DirectionsRendererOptions" object
  //     directionsDisplay.setMap(this.mapr); // map should be already initialized.
  //     var request = {
  //       origin: start,
  //       destination: end,
  //       travelMode: google.maps.TravelMode.DRIVING
  //     };
  //     var directionsService = new google.maps.DirectionsService();
  //     directionsService.route(request, function (response, status) {
  //       if (status == google.maps.DirectionsStatus.OK) {
  //         directionsDisplay.setDirections(response);
  //         bounds.extend(start);
  //         this.mapr.fitBounds(bounds);
  //       }
  //     });
  //   }, 100);
  // }
  changebid(bid) {
    this.cancellation_bid = bid;
  }
  cancelReason(bid) {
    if (bid == 0) {
      bid = this.cancellation_bid;
    }
    $(".booking_loader_parent").show();
    this.cancel_reasons = [];
    this.cancellation_bid = "";
    this._service.cancelreasons({
      "userType": "1",
      "lang": myGlobals.lang
    }).subscribe((res: any) => {
      $(".booking_loader_parent").hide();
      if (res.errFlag == 0) {
        res.data.bid = bid;
        this.cancel_reasons = res.data;
        $("#appcancel_rs").modal('show');
        $("#details_task").modal('hide');
        this.cancellation_bid = bid;
      }
      else {
        alert(res.errMsg);
      }
    });

  }

  //  cancelappt(bid){

  //    var reason = $('input[name="quality"]:checked').val();
  //     this._dispatcherHomeService.cancelservice({
  //       "ent_reason":  reason,
  //       "ent_status": "3",
  //       "ent_booking_id": this.cancellation_bid,
  //     }).subscribe((res: any) => {
  //       if(res.errFlag==0){
  //              $("#appcancel_rs").modal('hide');
  //               swal(this.cancelbooking.bookingCancel,this.cancelbooking.cancelCharges, this.cancelbooking.success);
  //               $("#details_task").modal('hide');
  //             this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
  //               this._dispatcherHomeService.getdata({
  //               // "ent_start_date":"",
  //               // "ent_page_index": "0",
  //               // "ent_booking_id":this.cancellation_bid,
  //               bookingId: bid
  //             }).subscribe((res: any) => {
  //                       console.log(this.cancelbooking.appoint,res);
  //                       console.log(this.cancelbooking.bfrbooking,this.data1);
  //                       this.data1 = jQuery.grep(this.data1, (value) => {
  //                                 return value.bid != this.cancellation_bid;
  //                             });
  //                       this.data1.splice(0, 0, res.data.appointments[0]);
  //                       console.log(this.cancelbooking.aftbooking,this.data1);
  //                       this.cancel_status_link=0;
  //                        setTimeout(function(){ $("tr#"+this.cancellation_bid).addClass('color_changing'); }, 500);
  //             });
  //       }
  //       else{
  //              alert(res.errMsg);
  //       }

  //     });
  //  }
  // EXPORT TASKS IN CSV FORMAT
  exportToCsv(filename, rows) {
    var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] == null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        };
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
          result = '"' + result + '"';
        if (j > 0)
          finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  // CANCEL APPOINTMENT FROM POP UP WHENC CLICKED ON CANCEL

  // cancel_service(driver_bid) {
  //   if (this.cancel_status_link == 1) {
  //     this.ent_driver_bid = this.driver_bid;
  //   }
  //   else {
  //     this.ent_driver_bid = driver_bid;
  //   }
  //   console.log("driver_bid", driver_bid);
  //   console.log(this.driver_bid);

  //   this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
  //   this._dispatcherService.cancelservice({
  //     "ent_reason": localStorage.getItem('devid'),
  //     "ent_status": this.current_time,
  //     "ent_booking_id": this.ent_driver_bid,
  //   }).subscribe((res: any) => {
  //     console.log("cancel_service");
  //     this.cancel_status_link = 0;
  //     console.log(res: any);
  //     if (res.errFlag == 0) {
  //       swal(this.cancelbooking.bookingCancel, this.cancelbooking.cancelCharges, this.cancelbooking.success)

  //       this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
  //       this._dispatcherHomeService.getdata({
  //         // "ent_start_date": "",
  //         // "ent_page_index": "0",
  //         // "ent_booking_id": this.ent_driver_bid,
  //         bookingId: driver_bid
  //       }).subscribe((res: any) => {
  //         console.log(this.cancelbooking.appoint, res);
  //         console.log(this.cancelbooking.bfrbooking, this.data1);
  //         this.data1 = jQuery.grep(this.data1, (value) => {
  //           return value.bid != this.ent_driver_bid;
  //         });
  //         this.data1.splice(0, 0, res.appointments[0]);
  //         console.log(this.cancelbooking.aftbooking, this.data1);
  //         this.cancel_status_link = 0;
  //       });
  //     }
  //     else {
  //       alert(res.errMsg);
  //     }
  //   });
  // }

  passDetails(i: number) {
    this.allroute_markers.map(marker => marker.setMap(null));
    $("#job_details_button").trigger('click');
    this.passDetailsContent = this.bookings[i];
    this.showbooking_content = this.bookings[i];
    console.log('this.showbooking_content', this.showbooking_content);
    // this.getCustomerBookings(this.passDetailsContent.bookingId);
    // console.log(" details error", this.passDetailsContent);

    if (this.passDetailsContent.bookingStatus === 12) {
      this.route_map_lt = this.passDetailsContent.pickup.location;
      this.route_map_lng = this.passDetailsContent.drop.location;
      setTimeout(() => {
        this.displayRoute();
      }, 400);
    }
  }

  hideShow_job() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#job_details_button").addClass("active");
    $('.details_description').show();
  }
  hideShow_activity() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#activity_timeline_button").addClass("active");
    $('.details_description2').show();
  }
  hideShow_path() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#path_history_button").addClass("active");
    $('.details_description3').show();
    // this.displayRoute();
  }
  hideShow_docs() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#documents_show").addClass("active");
    $('.details_description4').show();
  }
  hideShow_invoice() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#invoice_show").addClass("active");
    $('.details_description5').show();
  }
  // EXPORT CSV TASKS 3 FUNCTIONS ON CLICK IN EXPORTS POPUP 
  all_tasks() {
    $("#date_range_div").hide();
    this.request_all = "All";
    this.all_task = true;
    this.today_task = false;
    this.custom_select = false;
  }
  today_tasks() {
    this.request_all = "";
    $("#date_range_div").hide();
    this.today_task = true;
    this.all_task = false;
    this.custom_select = false;
  }
  custom_selection() {
    this.request_all = "";
    $("#date_range_div").show();
    this.all_task = false;
    this.today_task = false;
    this.custom_select = true;
  }

  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);
    console.log(data[0]);
    console.log("keyssss--------------------------------------------", keys);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });
    return result;
  }

  downloadCSV(args) {
    var data, filename, link;
    var csv = this.convertArrayOfObjectsToCSV({
      data: this.stockData
    });
    if (csv == null) return;
    filename = args.filename || 'export.csv';
    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  }

  // export_csv_file(){

  //     this._dispatcherService.getdet({
  //       "ent_date_time": this.export_start_date,
  //       "ent_start_date":this.export_start_date,
  //       "ent_end_time":this.export_end_date,
  //       "ent_page_index": this.ent_page_index.toString(),
  //       "ent_request":this.request_all,
  //     }).subscribe((res: any) => {
  //       console.log("response------------------------------",res);
  //      if(res.errFlag==0){
  // if(res.appointments.length<1){
  //   alert(this.cancelbooking.noBookingsAtDay);
  // }
  // else{
  //   this.bulk_array=[];
  // for(var stock =0;stock< res.appointments.length;stock++){

  //       if(res.appointments[stock].shipemntDetails[0].DriverArrivedTime == 0 || res.appointments[stock].shipemntDetails[0].DriverArrivedTime == ''){
  //          res.appointments[stock].shipemntDetails[0].DriverArrivedTime = 'NA'
  //       }
  //       if(res.appointments[stock].shipemntDetails[0].DriverOnTheWayTime == 0 || res.appointments[stock].shipemntDetails[0].DriverOnTheWayTime == ''){
  //           res.appointments[stock].shipemntDetails[0].DriverOnTheWayTime = 'NA'
  //       }
  //       if(res.appointments[stock].shipemntDetails[0].DriverArrivedTime == 0 || res.appointments[stock].shipemntDetails[0].DriverArrivedTime == ''){
  //         res.appointments[stock].shipemntDetails[0].DriverArrivedTime = 'NA'
  //       }
  //       if(res.appointments[stock].shipemntDetails[0].DriverLoadedStartedTime == 0 || res.appointments[stock].shipemntDetails[0].DriverLoadedStartedTime == ''){
  //         res.appointments[stock].shipemntDetails[0].DriverLoadedStartedTime = 'NA'
  //       }

  //       if(res.appointments[stock].shipemntDetails[0].DriverDropedTime == 0 || res.appointments[stock].shipemntDetails[0].DriverDropedTime == ''){
  //         res.appointments[stock].shipemntDetails[0].DriverDropedTime = 'NA';
  //       }

  //       if(res.appointments[stock].driverId == 0 || res.appointments[stock].driverId == ''){
  //         res.appointments[stock].driverId = 'NA';
  //       }
  //       if(res.appointments[stock].driverPhone == 0 || res.appointments[stock].driverPhone == ''){
  //         res.appointments[stock].driverPhone = 'NA';
  //       }
  //       if(res.appointments[stock].DriverName == 0 || res.appointments[stock].DriverName == ''){
  //         res.appointments[stock].DriverName= 'NA';
  //       }

  // res.appointments[stock].addrLine1 = this.convertString(res.appointments[stock].addrLine1);
  // res.appointments[stock].shipemntDetails[0].address = this.convertString(res.appointments[stock].shipemntDetails[0].address);
  // this.bulk_array.push({
  //   BID: res.appointments[stock].bid,
  //   RECEIVER_NAME: res.appointments[stock].shipemntDetails[0].name,
  //   RECEIVER_PHONE: res.appointments[stock].shipemntDetails[0].mobile,
  //   ORDER_PLACED_AT: res.appointments[stock].booking_time,
  //   PICKUP_ADDRESS :res.appointments[stock].addrLine1,
  //   DROP_ADDRESS:  res.appointments[stock].shipemntDetails[0].address,
  //   DRIVER_ID:res.appointments[stock].driverId,
  //   DRIVER_PHONE:res.appointments[stock].driverPhone,
  //   DRIVER_NAME:res.appointments[stock].DriverName,
  //   VEHICLE_TYPE:res.appointments[stock].vehicleType,
  //   TASK_STATUS:res.appointments[stock].status,
  //   PICKUP_ZONE_TITLE:res.appointments[stock].shipemntDetails[0].zone1,
  //   DROP_ZONE_TITLE :res.appointments[stock].shipemntDetails[0].zone2,
  //   PRODUCT_DESCRIPTION:res.appointments[stock].extraNotes,
  //   PRODUCT_WEIGHT:res.appointments[stock].shipemntDetails[0].weight,
  //   PRODUCT_QUANTITY:res.appointments[stock].shipemntDetails[0].quantity,
  //   FARE:res.appointments[stock].shipemntDetails[0].Fare,
  //   PRODUCT_IMAGE:res.appointments[stock].shipemntDetails[0].photo,
  //   PICKUP_TIME:res.appointments[stock].apntDt,
  //   DROP_TIME:res.appointments[stock].shipemntDetails[0].AproxDropTime,
  //   STATUS:res.appointments[stock].status, 
  //   BOOKING_CREATED_AT:res.appointments[stock].booking_time,
  //   DRIVER_ACCEPTED_TIME:res.appointments[stock].shipemntDetails[0].DriverAcceptedTime,
  //   DRIVER_ONTHEWAY_TIME:res.appointments[stock].shipemntDetails[0].DriverOnTheWayTime,
  //   DRIVER_ARRIVED_TIME:res.appointments[stock].shipemntDetails[0].DriverArrivedTime, 
  //   DRIVER_BOOKING_STARTED:res.appointments[stock].shipemntDetails[0].DriverLoadedStartedTime,
  //   DRIVER_DROPPED_TIME:res.appointments[stock].shipemntDetails[0].DriverDropedTime,
  //   DRIVER_COMPLETED_TIME:res.appointments[stock].shipemntDetails[0].DriverCompletedTime,
  // });
  // }


  //   this.stockData = this.bulk_array;
  //  this.downloadCSV({ filename: "stock-data.csv" });
  // }
  //      }
  //      else{
  //        alert(res.errMsg);
  //      }
  //     });

  // }
  convertString(phrase) {
    var maxLength = 100;

    var returnString = phrase.toLowerCase();
    //Convert Characters
    returnString = returnString.replace(/ö/g, 'o');
    returnString = returnString.replace(/ç/g, 'c');
    returnString = returnString.replace(/ş/g, 's');
    returnString = returnString.replace(/ı/g, 'i');
    returnString = returnString.replace(/ğ/g, 'g');
    returnString = returnString.replace(/ü/g, 'u');

    // if there are other invalid chars, convert them into blank spaces
    returnString = returnString.replace(/[^a-z0-9\s-]/g, "");
    // convert multiple spaces and hyphens into one space       
    returnString = returnString.replace(/[\s-]+/g, " ");
    // trims current string
    returnString = returnString.replace(/^\s+|\s+$/g, "");
    // cuts string (if too long)
    if (returnString.length > maxLength)
      returnString = returnString.substring(0, maxLength);
    // add hyphens
    returnString = returnString.replace(/\s/g, "-");

    return returnString;
  }

  ngOnInit() {
    this.outoff = this.limit;
    this.myname = this._cookie.getItem('firstName');
    this.myphn = this._cookie.getItem('phone');
    this.mymail = this._cookie.getItem('email');
    this.range = 10;
    this.getAllBooking();
    // this.getCustomerBooking();

    // Toaseter
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-right",
      "preventDuplicates": true,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "8000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    $(".booking_buutns").hide();
    // this.fname_b = this._cookie.getProfile('firstName');
    // this.fmail_b = this._cookie.getProfile('email');
    // this.fphone_b = this._cookie.getProfile('phone');

    // this.get_det();
    $('#bulk_export_button_tasks').click(() => {
      this.current_time = moment().format('YYYY-MM-DD');
      if (this.today_task == true) {
        this.export_start_date = this.current_time;
        this.export_end_date = "";
        // this.export_csv_file();
        console.log("export_button_click");
      }
      else if (this.custom_select = true) {
        this.export_start_date = $(".bulk_export_date").val();
        this.export_end_date = $(".bulk_export_date2").val();
        //  this.export_csv_file();
        console.log(this.export_start_date);
        console.log(this.export_end_date);
      }
    });

    $("#load_next").click(() => {
      this.ent_page_index++;
      // this.get_det();
    });
    $('#tasks_refresh').click(() => {
      this.data1 = [];
      // this.get_det();
    });

    $("button.confirm").click(function () {
    }
    );
    $('.filters_but').click(function () {
      $('#filters_but_body').toggle();
      $('.filters_but .glyphicon.glyphicon-triangle-bottom').toggleClass('active');
    })
    // var that = this;
    // $('#filters_but_body li').click(function () {
    //   if ($(this).text() == "All Bookings") {
    //     this.search = "";
    //   }
    //   else
    //     this.search = $(this).text();
    //     this.getAllBooking();
    //   $('#filters_but_body li').removeClass('active');
    //   $(this).addClass('active');
    //   $('.filters_but .glyphicon.glyphicon-triangle-bottom').toggleClass('active');
    //   $('#filters_but_body').toggle();
    // })

    $("#hidden_flipping_assign").click(() => {
      var content = $("#hidden_flipping_assign").text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      var status = splitted_content[1];
      var msg = splitted_content[2];
      var date_bid = splitted_content[3];
      $("tr#" + bid).removeClass('color_changing');
      for (var inst = 0; inst < this.data1.length; inst++) {
        if (this.data1[inst].bid == bid) {
          console.log(bid);

          this.data1[inst].shipemntDetails[0].status = status;
          this.data1[inst].status = msg;
          console.log(this.data1[inst]);
          console.log("before-bookingbidno", date_bid, this.data1[inst]);
          switch (status) {
            case "7":
              this.data1[inst].shipemntDetails[0].DriverArrivedTime = date_bid;
              break;
            case "8":
              this.data1[inst].shipemntDetails[0].DriverLoadedStartedTime = date_bid;
              break;
            case "9":
              this.data1[inst].shipemntDetails[0].DriverReachedDropLocationTime = date_bid;
              break;
            case "16":
              this.data1[inst].shipemntDetails[0].DriverDropedTime = date_bid;
              break;
          }
          console.log("bookingbidno", this.data1[inst]);
          break;
        }
      }
      setTimeout(function () { $("tr#" + bid).addClass('color_changing'); }, 500);
    });

    $("#hidden_flipping_expired").click(() => {
      var bid = $("#hidden_flipping_expired").text();
      $("tr#" + bid).removeClass('color_changing');
      this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
      this._service.getdata({
        // "ent_start_date": "",
        // "ent_page_index": "0",
        // "ent_booking_id": bid,
        bookingId: bid
      }).subscribe((res: any) => {
        this.data1 = jQuery.grep(this.data1, (value) => {
          return value.bid != this.ent_driver_bid;
        });
        this.data1.splice(0, 0, res.data.appointments[0]);
        console.log("afterbooking", this.data1);
        this.cancel_status_link = 0;
      });
      setTimeout(function () { $("tr#" + bid).addClass('color_changing'); }, 500);
    });

    $("#hidden_flipping").click(() => {
      var content = $("#hidden_flipping").text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      $("tr#" + bid).removeClass('color_changing');
      var status = splitted_content[1];
      this._service.getdata({
        // "ent_page_index": "0",
        // "ent_booking_id": bid,
        bookingId: bid
      }).subscribe((res: any) => {
        console.log("signalbooking", res);
        if (res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime != undefined) {
          if (res.data.appointments[0].bookingTimeStamp != "0") {
            res.data.appointments[0].booking_time = moment.unix(res.data.appointments[0].bookingTimeStamp).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime != "0") {
            res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime).format("MMMM Do YYYY, h:mm:ss a");


          if (res.data.appointments[0].shipemntDetails[0].DriverArrivedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverArrivedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverArrivedTime).format("MMMM Do YYYY, h:mm:ss a");

          if (res.data.appointments[0].shipemntDetails[0].DriverCompletedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverCompletedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverCompletedTime).format("MMMM Do YYYY, h:mm:ss a");

          if (res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime).format("MMMM Do YYYY, h:mm:ss a");

          if (res.data.appointments[0].shipemntDetails[0].DriverDropedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverDropedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverDropedTime).format("MMMM Do YYYY, h:mm:ss a");
        }

        if (status == "6") {
          this.data1 = jQuery.grep(this.data1, (value) => {
            return value.bid != res.data.appointments[0].bid;
          });
          this.data1.splice(0, 0, res.data.appointments[0]);
        }
        else if (status == "10") {
          this.data1 = jQuery.grep(this.data1, (value) => {
            return value.bid != res.data.appointments[0].bid;
          });
          this.data1.splice(0, 0, res.data.appointments[0]);
        }
        setTimeout(function () { $("tr#" + bid).addClass('color_changing'); }, 500);
      });
    });

    $('#search_date_range').click(() => {
      this.fromDate = $(".flatpickr1").val();
      this.toDate = $(".flatpickrb").val();
      this.status = '';
      this.search = '';
      $('#searchKey').val('');
      if (this.fromDate == "" || this.toDate == "") {
        alert(this.cancelbooking.validDateRange);
      }
      else {
        this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
        $("#loader_bookings_parent").show();
        this.getAllBooking();
      }
    });
    //  $('#searchKeyRange').click(()=>{
    //   this.search = $("#searchKey").val();
    //   if(this.search==""){
    //     alert("Please enter valid keyword!");
    //   } 
    //   else{
    //    $("#loader_bookings_parent").show();
    //    this.getAllBooking();
    //  }
    // });

    jQuery('#back_button').show();
    flatpickr(".flatpickr1", {
      defaultDate: new Date(), // Date objects and date strings are also accepted
      enableTime: false,
      // minDate: new Date(), // "today" / "2016-12-20" / 1477673788975
      // maxDate: "2018-12-20",
      altFormat: "M j, Y"
    });
    flatpickr(".flatpickrb", {
      defaultDate: new Date(), // Date objects and date strings are also accepted
      enableTime: false,
      // minDate: new Date(), // "today" / "2016-12-20" / 1477673788975
      // maxDate: "2018-12-20",
      altFormat: "M j, Y"
    });
  }

  // START OF UBER FOR ALL API CALLS
  page_index: any;
  assigned_count: any;
  completed_count: any;
  assigned_full_count: any;

  assigned = [];
  unassigned = [];
  past = [];
  errMsg: any;
  getCustomerBooking() {
    if (this.page_index == 0) {
      this.assigned_count = 0;
      this.completed_count = 0;
      this.assigned_full_count = 0;
    }
    $("#loader_bookings_parent").show();
    this._service.gethistory({
    }).subscribe((res: any) => {
      console.log("booking history appointments++++++++++++++++++++++++++++++++++", res);
      $("#loader_bookings_parent").hide();
      if (res.data.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
      }
      else {
        var response_ins = 0;
        const bookingData = res.data;
        for (let asgn = 0; asgn < bookingData.assigned.length; asgn++) {
          if (bookingData.assigned.status == 6, 7, 8, 9, 10, 11) {
            this.assigned.push(bookingData.assigned[asgn]);
            this.assigned_count = this.assigned.length;
          }
          console.log("drop address: ", bookingData.assigned[asgn].dropAddress);
          // if(bookingData.assigned[asgn].dropAddress != '') {
          //   this.dropDetails = true;
          // } else {
          //   this.dropDetails = false;
          // }
        }

        for (let unasgn = 0; unasgn < bookingData.unassigned.length; unasgn++) {
          if (bookingData.unassigned[unasgn].status == 2) {
            this.unassigned.push(bookingData.unassigned[unasgn]);
            this.assigned_full_count = this.unassigned.length;
          }
        }

        for (let past = 0; past < bookingData.past.length; past++) {
          if (bookingData.past[past].status == 3, 4, 5, 12, 13) {
            this.past.push(bookingData.past[past]);
            console.log('inpast');
            this.completed_count = this.past.length;
          }
          // if(bookingData.past.dropAddress == '') {
          //   this.showdropaddress = false;
          // }
        }
        let two = this.assigned.concat(this.unassigned);
        this.data1 = two.concat(this.past);
        console.log("all bookings: ", this.data1);
      }
    })
    //, (err) => {
    //   console.log('errMsg', err.status);
    //   if(err.status>401&&err.status<500){
    //     err.status = 420; // merging all the status codes to one status code 420
    //   }
    //   if(err.status>499){
    //     err.status = 520; // merging all the status codes to one status code 420
    //   }
    //   switch(err.status) {
    //     case 0:
    //       $("#loader_bookings_parent").hide();
    //       toastr["error"]("Bad Request!");
    //       break;
    //     case 520:
    //       $("#loader_bookings_parent").hide();
    //       this.errMsg = JSON.parse(err.error);
    //       toastr["error"](this.errMsg.message);
    //       break;
    //     case 400:
    //       $("#loader_bookings_parent").hide();
    //       this.errMsg = JSON.parse(err.error);
    //       toastr["error"](this.errMsg.message);
    //       break;
    //     case 401:
    //       this._cookie.removeItem();
    //       this._router.navigate(['login']);
    //       break;
    //     case 420:
    //       $("#loader_bookings_parent").hide();
    //       this.errmessage = JSON.parse(err.error);
    //       console.log(this.errmessage.message);
    //       this.errmessage = this.errmessage.message;
    //       break;
    //   }
    // })
  }



  // END OF UBER FOR ALL API CALLS
}